<template>
  <div>
    <label :for="name" :class="{ 'sr-only': !label, 'block text-sm font-semibold text-blumine mb-1': label }">
      {{ label }} <span v-if="required" class="text-shakespear">*</span>
    </label>
    <div class="border-big-stone border-opacity-25">
      <input
        :id="name"
        :type="type"
        :required="required"
        :readonly="isLoading || readonly"
        :disabled="disabled"
        :value="modelValue"
        :autocomplete="autocomplete"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="$emit('update:modelValue', $event.target.value)"
        :class="{ 'bg-gray-50': readonly || disabled, 'pl-6': search, ' mt-1': label }"
        class="block w-full border-big-stone border-opacity-20 rounded-md text-blumine placeholder-gray-500 focus:ring-sail focus:border-sail focus:outline-none focus:shadow-outline-sail transition duration-150 ease-in-out"
      >
    </div>
    <error v-if="error">{{ error }}</error>
  </div>
</template>

<script>
import Error from '@/components/form/Error.vue'

export default {
  components: {
    Error
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    modelValue: {},
    error: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    maxlength: {},
  }
}
</script>
